// extracted by mini-css-extract-plugin
module.exports = {"styled-img":"Banner_styled-img__xk5F5","styled-link":"Banner_styled-link__cEp_1","wrap-banner":"Banner_wrap-banner__kxDb_"};